module.exports = __webpack_public_path__ + "img/product-shot_05.51375a2e.jpg";